import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row gx-1" }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = { class: "form-group mb-2 mb-sm-2 mb-md-2" }
const _hoisted_6 = { class: "col" }
const _hoisted_7 = { class: "form-group mb-2 mb-sm-2 mb-md-2" }
const _hoisted_8 = { class: "col" }
const _hoisted_9 = { class: "form-group mb-2 mb-sm-2 mb-md-2" }
const _hoisted_10 = { class: "col" }
const _hoisted_11 = { class: "form-group mb-2 mb-sm-2 mb-md-2" }
const _hoisted_12 = { class: "col" }
const _hoisted_13 = { class: "form-group mb-2 mb-sm-2 mb-md-2" }
const _hoisted_14 = { class: "col" }
const _hoisted_15 = { class: "form-group mb-2 mb-sm-2 mb-md-2" }
const _hoisted_16 = { class: "col" }
const _hoisted_17 = { class: "form-group mb-2 mb-sm-2 mb-md-2" }
const _hoisted_18 = { class: "row gx-1" }
const _hoisted_19 = {
  key: 0,
  class: "col-md-2"
}
const _hoisted_20 = { class: "form-group mb-2 mb-sm-2 mb-md-2" }
const _hoisted_21 = { class: "col-md-2" }
const _hoisted_22 = { class: "form-group mb-2 mb-sm-2 mb-md-2" }
const _hoisted_23 = { class: "col-md-3" }
const _hoisted_24 = { class: "form-group mb-2 mb-sm-2 mb-md-2" }
const _hoisted_25 = { class: "d-block text-black fw-semibold" }
const _hoisted_26 = { class: "col-md-1" }
const _hoisted_27 = { class: "form-group mb-2 mb-sm-2 mb-md-2" }
const _hoisted_28 = {
  key: 1,
  class: "col-md-2"
}
const _hoisted_29 = { class: "form-group mb-2 mb-sm-2 mb-md-2" }
const _hoisted_30 = { class: "input-group" }
const _hoisted_31 = {
  key: 0,
  class: "text-warning d-block mt-1"
}
const _hoisted_32 = { class: "col-md-12 mb-md-25" }
const _hoisted_33 = { class: "accordion-body" }
const _hoisted_34 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_35 = {
  class: "tab-pane fade show active p-10",
  id: "home-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_36 = { class: "row gx-2" }
const _hoisted_37 = { class: "border border-primary mb-5" }
const _hoisted_38 = { class: "row gx-2 d-flex align-items-center justify-content-between fw-bold py-2 bg-primary" }
const _hoisted_39 = { class: "col-md-5" }
const _hoisted_40 = { class: "d-flex float-end" }
const _hoisted_41 = ["disabled"]
const _hoisted_42 = { class: "card-body p-1" }
const _hoisted_43 = { class: "row gx-1" }
const _hoisted_44 = { class: "col-4" }
const _hoisted_45 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_46 = { class: "col" }
const _hoisted_47 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_48 = { class: "col" }
const _hoisted_49 = { class: "d-block text-black fw-semibold" }
const _hoisted_50 = ["title"]
const _hoisted_51 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_52 = { class: "col" }
const _hoisted_53 = { class: "col" }
const _hoisted_54 = { class: "col" }
const _hoisted_55 = { class: "row gx-1" }
const _hoisted_56 = { class: "col-1" }
const _hoisted_57 = { class: "col" }
const _hoisted_58 = { class: "col" }
const _hoisted_59 = { class: "col" }
const _hoisted_60 = { class: "col" }
const _hoisted_61 = { class: "col" }
const _hoisted_62 = { class: "col" }
const _hoisted_63 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_64 = { class: "col" }
const _hoisted_65 = { class: "mb-1" }
const _hoisted_66 = { class: "pt-0" }
const _hoisted_67 = {
  class: "tab-pane fade p-10",
  id: "home2-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_68 = { class: "row" }
const _hoisted_69 = { class: "border border-primary mb-5" }
const _hoisted_70 = {
  class: "row d-flex align-items-center justify-content-between fw-bold py-2",
  style: {"background-color":"#0a59a4 !important"}
}
const _hoisted_71 = { class: "col-md-5" }
const _hoisted_72 = { class: "d-flex float-end" }
const _hoisted_73 = ["disabled"]
const _hoisted_74 = { class: "col-md-3 mb-5" }
const _hoisted_75 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_76 = { class: "col-md-3 mb-5" }
const _hoisted_77 = { class: "col-md-2 mb-5" }
const _hoisted_78 = { class: "col-md-2 mb-5" }
const _hoisted_79 = { class: "col-md-1 mb-5" }
const _hoisted_80 = ["onClick"]
const _hoisted_81 = {
  key: 0,
  class: "alert alert-danger mx-auto mb-2 py-1",
  role: "alert",
  style: {"max-width":"600px"}
}
const _hoisted_82 = { class: "table-responsive" }
const _hoisted_83 = { class: "table table-fixed text-nowrap align-middle mb-0 table-bordered" }
const _hoisted_84 = { class: "produit-col" }
const _hoisted_85 = { class: "info" }
const _hoisted_86 = { class: "quantite-col" }
const _hoisted_87 = { class: "prix-unitaire-col" }
const _hoisted_88 = { class: "taxe-col" }
const _hoisted_89 = { class: "taxe-col" }
const _hoisted_90 = { class: "taxe-col" }
const _hoisted_91 = { class: "type-rse-col" }
const _hoisted_92 = { class: "vente-rse-col" }
const _hoisted_93 = { class: "taxe-col" }
const _hoisted_94 = { class: "taxe-col" }
const _hoisted_95 = { class: "taxe-col" }
const _hoisted_96 = { class: "taxe-col" }
const _hoisted_97 = { class: "magasin-col" }
const _hoisted_98 = { class: "actions-col pe-0" }
const _hoisted_99 = {
  class: "button-container",
  style: {"white-space":"nowrap"}
}
const _hoisted_100 = ["onClick"]
const _hoisted_101 = ["onClick"]
const _hoisted_102 = ["onClick"]
const _hoisted_103 = {
  class: "modal fade",
  id: "stockDetailsModal",
  tabindex: "-1",
  "aria-labelledby": "stockDetailsModalLabel",
  "aria-hidden": "true"
}
const _hoisted_104 = {
  class: "modal-dialog modal-lg",
  style: {"display":"flex","align-items":"center","min-height":"calc(100vh - 1rem)","margin":"0.5rem auto"}
}
const _hoisted_105 = { class: "modal-content" }
const _hoisted_106 = { class: "modal-body" }
const _hoisted_107 = { class: "row mb-3" }
const _hoisted_108 = { class: "col-12" }
const _hoisted_109 = { class: "row mb-3" }
const _hoisted_110 = { class: "col-md-3" }
const _hoisted_111 = { class: "col-md-3" }
const _hoisted_112 = { class: "col-md-3" }
const _hoisted_113 = { class: "col-md-3" }
const _hoisted_114 = { class: "row mb-3" }
const _hoisted_115 = { class: "col-md-3" }
const _hoisted_116 = { class: "col-md-3" }
const _hoisted_117 = { class: "col-md-3" }
const _hoisted_118 = { class: "col-md-3" }
const _hoisted_119 = { class: "row mb-3" }
const _hoisted_120 = { class: "col-md-3" }
const _hoisted_121 = { class: "col-md-3" }
const _hoisted_122 = { class: "col-md-3" }
const _hoisted_123 = { class: "col-md-3" }
const _hoisted_124 = {
  class: "modal fade",
  id: "billetagePaiementModal",
  tabindex: "-1",
  "aria-labelledby": "billetagePaiementModalLabel",
  "aria-hidden": "true"
}
const _hoisted_125 = { class: "modal-dialog modal-xl" }
const _hoisted_126 = { class: "modal-content" }
const _hoisted_127 = { class: "modal-body" }
const _hoisted_128 = { class: "row" }
const _hoisted_129 = { class: "col-md-6 mb-3" }
const _hoisted_130 = { class: "border border-primary" }
const _hoisted_131 = {
  class: "row fw-bold py-2",
  style: {"background-color":"#0a59a4"}
}
const _hoisted_132 = { class: "col-md-5 text-end" }
const _hoisted_133 = {
  class: "fs-5 text-white mb-0",
  style: {"font-weight":"bold"}
}
const _hoisted_134 = { class: "px-3 py-2" }
const _hoisted_135 = { class: "col-md-4 px-1" }
const _hoisted_136 = ["onUpdate:modelValue"]
const _hoisted_137 = { class: "col-md-4 px-1" }
const _hoisted_138 = ["onUpdate:modelValue", "onInput"]
const _hoisted_139 = { class: "col-md-4 px-1" }
const _hoisted_140 = ["onUpdate:modelValue"]
const _hoisted_141 = { class: "col-md-6 mb-3" }
const _hoisted_142 = { class: "border border-danger" }
const _hoisted_143 = {
  class: "row fw-bold py-2",
  style: {"background-color":"#a40a0a"}
}
const _hoisted_144 = { class: "col-md-5 text-end" }
const _hoisted_145 = {
  class: "fs-5 text-white mb-0",
  style: {"font-weight":"bold"}
}
const _hoisted_146 = { class: "px-3 py-2" }
const _hoisted_147 = { class: "col-md-4 px-1" }
const _hoisted_148 = ["onUpdate:modelValue"]
const _hoisted_149 = { class: "col-md-4 px-1" }
const _hoisted_150 = ["onUpdate:modelValue", "onInput"]
const _hoisted_151 = { class: "col-md-4 px-1" }
const _hoisted_152 = ["onUpdate:modelValue"]
const _hoisted_153 = {
  key: 0,
  class: "alert alert-danger mt-2 py-2"
}
const _hoisted_154 = {
  key: 0,
  class: "alert alert-danger mt-2"
}
const _hoisted_155 = {
  key: 1,
  class: "alert alert-warning mt-2"
}
const _hoisted_156 = { class: "modal-footer" }
const _hoisted_157 = ["disabled"]
const _hoisted_158 = { class: "col-md-12 mt-5" }
const _hoisted_159 = { class: "row align-items-end" }
const _hoisted_160 = { class: "col-md-4" }
const _hoisted_161 = {
  class: "btn-group",
  role: "group"
}
const _hoisted_162 = ["disabled"]
const _hoisted_163 = ["disabled"]
const _hoisted_164 = { class: "dropdown-menu" }
const _hoisted_165 = {
  key: 0,
  class: "fa fa-print"
}
const _hoisted_166 = {
  key: 1,
  class: "fa fa-spinner fa-spin"
}
const _hoisted_167 = { class: "col-md-2" }
const _hoisted_168 = { class: "col-md-3" }
const _hoisted_169 = { class: "form-group mb-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!
  const _component_AddClientModal = _resolveComponent("AddClientModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Form, {
          onSubmit: _ctx.transformerProforma,
          "validation-schema": _ctx.venteSchema,
          "keep-values": _ctx.valuess
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _cache[41] || (_cache[41] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, " Date commande ", -1)),
                  _createVNode(_component_Field, {
                    name: "dateCommande",
                    readonly: true,
                    value: _ctx.getCurrentDate(),
                    type: "date",
                    class: "form-control shadow-none fs-md-15 text-black",
                    placeholder: ""
                  }, null, 8, ["value"])
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _cache[42] || (_cache[42] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, " Montant HT ", -1)),
                  _createVNode(_component_Field, {
                    modelValue: _ctx.totalsomme,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.totalsomme) = $event)),
                    name: "montantHT",
                    readonly: true,
                    type: "text",
                    class: "form-control shadow-none fs-md-15 text-black",
                    placeholder: ""
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _cache[43] || (_cache[43] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, " Montant HT RSE ", -1)),
                  _createVNode(_component_Field, {
                    modelValue: _ctx.totalsommeremise,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.totalsommeremise) = $event)),
                    name: "montantHTRSE",
                    readonly: true,
                    type: "text",
                    class: "form-control shadow-none fs-md-15 text-black",
                    placeholder: ""
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _cache[44] || (_cache[44] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, " Montant TVA ", -1)),
                  _createVNode(_component_Field, {
                    modelValue: _ctx.totaltva,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.totaltva) = $event)),
                    name: "montantTVA",
                    readonly: true,
                    type: "text",
                    class: "form-control shadow-none fs-md-15 text-black",
                    placeholder: ""
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _cache[45] || (_cache[45] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, " Montant AIB ", -1)),
                  _createVNode(_component_Field, {
                    modelValue: _ctx.totalaib,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.totalaib) = $event)),
                    name: "montantAIB",
                    readonly: true,
                    type: "text",
                    class: "form-control shadow-none fs-md-15 text-black",
                    placeholder: ""
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _cache[46] || (_cache[46] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, " Montant Taxe S. ", -1)),
                  _createVNode(_component_Field, {
                    modelValue: _ctx.totalts,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.totalts) = $event)),
                    name: "montanTS",
                    readonly: true,
                    type: "text",
                    class: "form-control shadow-none fs-md-15 text-black",
                    placeholder: ""
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _cache[47] || (_cache[47] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, " Montant TTC ", -1)),
                  _createVNode(_component_Field, {
                    modelValue: _ctx.totalttc,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.totalttc) = $event)),
                    name: "montantTTC",
                    readonly: true,
                    type: "text",
                    class: "form-control shadow-none fs-md-15 text-black",
                    placeholder: ""
                  }, null, 8, ["modelValue"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              (_ctx.typeFacture !== 'Facture proforma')
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _cache[48] || (_cache[48] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                        _createTextVNode(" Type Commande "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createVNode(_component_Field, {
                        name: "typeCommande",
                        modelValue: _ctx.typeC,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.typeC) = $event))
                      }, {
                        default: _withCtx(({ field }) => [
                          _createVNode(_component_Multiselect, _mergeProps({
                            options: ['Au comptoir', 'Sur commande'],
                            searchable: true,
                            "track-by": "label",
                            label: "label",
                            modelValue: field.value,
                            "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                          }, field, {
                            placeholder: "Sélectionner le groupe de taxe",
                            onSelect: ($event: any) => (_ctx.showHide(field.value))
                          }), null, 16, ["modelValue", "onUpdate:modelValue", "onSelect"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createVNode(_component_ErrorMessage, {
                      name: "groupeTaxe",
                      class: "text-danger"
                    })
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _cache[49] || (_cache[49] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                    _createTextVNode(" Type Facture "),
                    _createElementVNode("span", { class: "text-danger" }, "*")
                  ], -1)),
                  _createVNode(_component_Field, {
                    name: "typeFacture",
                    modelValue: _ctx.typeFacture,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.typeFacture) = $event))
                  }, {
                    default: _withCtx(({ field }) => [
                      _createVNode(_component_Multiselect, _mergeProps({
                        options: ['Facture de vente'],
                        searchable: false,
                        "track-by": "label",
                        label: "label",
                        modelValue: field.value,
                        "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                      }, field, {
                        disabled: true,
                        placeholder: "Facture de vente"
                      }), null, 16, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createVNode(_component_ErrorMessage, {
                  name: "modePrix",
                  class: "text-danger"
                })
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("label", _hoisted_25, [
                    _cache[52] || (_cache[52] = _createTextVNode(" Client ")),
                    _cache[53] || (_cache[53] = _createElementVNode("span", { class: "text-danger" }, "*", -1)),
                    (!_ctx.selectedClient)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          style: {"float":"right"},
                          class: "btn btn-success me-3 btn-xs b-r-6",
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#AddClientModal",
                          onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.toggleAbonne && _ctx.toggleAbonne(...args)))
                        }, _cache[50] || (_cache[50] = [
                          _createElementVNode("i", { class: "fa fa-plus-circle" }, null, -1),
                          _createTextVNode(" Ajouter un client ")
                        ])))
                      : _createCommentVNode("", true),
                    (_ctx.selectedClient)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          style: {"float":"right"},
                          class: "btn btn-success me-3 btn-xs",
                          onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.toggleAbonne && _ctx.toggleAbonne(...args)))
                        }, _cache[51] || (_cache[51] = [
                          _createElementVNode("i", { class: "fa fa-plus-circle" }, null, -1),
                          _createTextVNode(" Rechercher un client ")
                        ])))
                      : _createCommentVNode("", true)
                  ]),
                  (!_ctx.selectedClient)
                    ? (_openBlock(), _createBlock(_component_Field, {
                        key: 0,
                        name: "client",
                        modelValue: _ctx.clientCharger,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.clientCharger) = $event))
                      }, {
                        default: _withCtx(({ field }) => [
                          _createVNode(_component_Multiselect, _mergeProps({
                            options: _ctx.clientOptions,
                            searchable: true,
                            "track-by": "label",
                            label: "label",
                            modelValue: field.value,
                            "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                          }, field, { placeholder: "Sélectionner le client" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"]))
                    : (_openBlock(), _createBlock(_component_Field, {
                        key: 1,
                        name: "client",
                        modelValue: _ctx.selectedClientId,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.selectedClientId) = $event))
                      }, {
                        default: _withCtx(({ field }) => [
                          _createVNode(_component_Multiselect, {
                            modelValue: field.value,
                            "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                            options: _ctx.clientsOps,
                            placeholder: "Sélectionner un client"
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"]))
                ]),
                _createVNode(_component_ErrorMessage, {
                  name: "client",
                  class: "text-danger"
                })
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _cache[54] || (_cache[54] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, " TAUX AIB ", -1)),
                  _createVNode(_component_Field, {
                    name: "tauxAIB",
                    modelValue: _ctx.valeurAib,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.valeurAib) = $event))
                  }, {
                    default: _withCtx(({ field }) => [
                      _createVNode(_component_Multiselect, _mergeProps({
                        options: ['1%','5%'],
                        searchable: true,
                        "track-by": "label",
                        label: "label",
                        modelValue: field.value,
                        "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                      }, field, { placeholder: "Choisir" }), null, 16, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createVNode(_component_ErrorMessage, {
                  name: "tauxAIB",
                  class: "text-danger"
                })
              ]),
              (_ctx.showC)
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _cache[57] || (_cache[57] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                        _createTextVNode(" Montant Reçu "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_30, [
                        _createVNode(_component_Field, {
                          name: "montantReçu",
                          type: "text",
                          modelValue: _ctx.montantReçu,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.montantReçu) = $event)),
                          modelModifiers: { number: true },
                          class: "form-control shadow-none fs-md-15 text-black",
                          placeholder: "Montant reçu",
                          readonly: ""
                        }, null, 8, ["modelValue"]),
                        _cache[55] || (_cache[55] = _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-primary",
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#billetagePaiementModal",
                          title: "Ouvrir le billetage"
                        }, [
                          _createElementVNode("i", { class: "fa fa-calculator" })
                        ], -1))
                      ]),
                      _createVNode(_component_ErrorMessage, {
                        name: "montantReçu",
                        class: "text-danger"
                      }),
                      (_ctx.reliquatNonRendu > 0)
                        ? (_openBlock(), _createElementBlock("small", _hoisted_31, [
                            _cache[56] || (_cache[56] = _createElementVNode("i", { class: "fa fa-exclamation-triangle" }, null, -1)),
                            _createTextVNode(" Reliquat non rendu: " + _toDisplayString(_ctx.reliquatNonRendu) + " Fcfa ", 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _cache[87] || (_cache[87] = _createElementVNode("ul", {
                    class: "nav nav-tabs",
                    id: "myTab",
                    role: "tablist"
                  }, [
                    _createElementVNode("li", {
                      class: "nav-item",
                      role: "presentation"
                    }, [
                      _createElementVNode("button", {
                        class: "nav-link active",
                        id: "home-tab",
                        "data-bs-toggle": "tab",
                        "data-bs-target": "#home-tab-pane",
                        type: "button",
                        role: "tab",
                        "aria-controls": "home-tab-pane",
                        "aria-selected": "true"
                      }, " Produit ")
                    ])
                  ], -1)),
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("div", _hoisted_37, [
                          _createElementVNode("div", _hoisted_38, [
                            _cache[59] || (_cache[59] = _createElementVNode("div", { class: "col-md-7" }, [
                              _createElementVNode("h4", { class: "fs-6 text-white" }, " Ajouter le produit ")
                            ], -1)),
                            _createElementVNode("div", _hoisted_39, [
                              _createElementVNode("div", _hoisted_40, [
                                _createElementVNode("button", {
                                  class: _normalizeClass(["default-btn me-20 transition border-0 fw-medium text-white pt-2 pb-2 ps-8 pe-8 rounded-1 fs-md-13 fs-lg-14 bg-success", { 'cursor-not-allowed': _ctx.isDisable }]),
                                  type: "button",
                                  disabled: _ctx.isDisable,
                                  onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.addRowProduit()))
                                }, [
                                  _cache[58] || (_cache[58] = _createElementVNode("i", { class: "fa fa-plus-circle" }, null, -1)),
                                  _createTextVNode(" " + _toDisplayString(_ctx.enModification ? 'Mettre à jour le produit' : 'Ajouter un produit'), 1)
                                ], 10, _hoisted_41)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_42, [
                              _createElementVNode("div", null, [
                                _createElementVNode("div", _hoisted_43, [
                                  _createElementVNode("div", _hoisted_44, [
                                    _cache[60] || (_cache[60] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, " Produit ", -1)),
                                    _createVNode(_component_Multiselect, {
                                      options: _ctx.produitOptions,
                                      searchable: true,
                                      "track-by": "label",
                                      label: "label",
                                      modelValue: _ctx.produit.produit,
                                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.produit.produit) = $event)),
                                      placeholder: "Selectionnez le produit",
                                      disabled: !_ctx.clientCharger,
                                      onSelect: _cache[16] || (_cache[16] = ($event: any) => (_ctx.selectProd(_ctx.produit.produit, _ctx.produit)))
                                    }, null, 8, ["options", "modelValue", "disabled"]),
                                    (_ctx.validateRowProduit(_ctx.produit.produit))
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_45, " Champ obligatoire "))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("div", _hoisted_46, [
                                    _cache[61] || (_cache[61] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, " Quantité ", -1)),
                                    _withDirectives(_createElementVNode("input", {
                                      type: "text",
                                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.produit.qtite) = $event)),
                                      class: _normalizeClass(_ctx.validateRowProduit(_ctx.produit.qtite) ? 'form-control is-invalid' : 'form-control'),
                                      placeholder: "Entrer la quantité",
                                      onKeyup: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.eventProduit && _ctx.eventProduit(...args)))
                                    }, null, 34), [
                                      [
                                        _vModelText,
                                        _ctx.produit.qtite,
                                        void 0,
                                        { number: true }
                                      ]
                                    ]),
                                    (_ctx.validateRowProduit(_ctx.produit.qtite))
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_47, " Champ obligatoire "))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("div", _hoisted_48, [
                                    _createElementVNode("label", _hoisted_49, [
                                      _cache[62] || (_cache[62] = _createTextVNode(" Prix unitaire ")),
                                      (_ctx.produit.prixMin && _ctx.produit.prixMax)
                                        ? (_openBlock(), _createElementBlock("i", {
                                            key: 0,
                                            class: "fa fa-info-circle text-muted ms-1",
                                            title: `Prix recommandé: ${_ctx.produit.prixMin} - ${_ctx.produit.prixMax}`,
                                            style: {"font-size":"12px","cursor":"help"}
                                          }, null, 8, _hoisted_50))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _withDirectives(_createElementVNode("input", {
                                      type: "text",
                                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.produit.prixTtc) = $event)),
                                      class: _normalizeClass(_ctx.validateRowProduit(_ctx.produit.prixTtc) ? 'form-control is-invalid' : 'form-control'),
                                      placeholder: "Entrer le prix",
                                      onKeyup: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.eventProduit && _ctx.eventProduit(...args)))
                                    }, null, 34), [
                                      [
                                        _vModelText,
                                        _ctx.produit.prixTtc,
                                        void 0,
                                        { number: true }
                                      ]
                                    ]),
                                    (_ctx.validateRowProduit(_ctx.produit.prixTtc))
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_51, " Champ obligatoire "))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("div", _hoisted_52, [
                                    _cache[63] || (_cache[63] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, " Prix HT ", -1)),
                                    _withDirectives(_createElementVNode("input", {
                                      type: "text",
                                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.produit.prixHt) = $event)),
                                      readonly: true,
                                      class: "form-control",
                                      placeholder: ""
                                    }, null, 512), [
                                      [_vModelText, _ctx.produit.prixHt]
                                    ]),
                                    _cache[64] || (_cache[64] = _createElementVNode("span", { class: "invalid-feedback" }, null, -1))
                                  ]),
                                  _createElementVNode("div", _hoisted_53, [
                                    _cache[65] || (_cache[65] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, " Montant HT ", -1)),
                                    _withDirectives(_createElementVNode("input", {
                                      type: "text",
                                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.produit.montantHt) = $event)),
                                      readonly: true,
                                      class: "form-control",
                                      placeholder: ""
                                    }, null, 512), [
                                      [_vModelText, _ctx.produit.montantHt]
                                    ]),
                                    _cache[66] || (_cache[66] = _createElementVNode("span", { class: "invalid-feedback" }, null, -1))
                                  ]),
                                  _createElementVNode("div", _hoisted_54, [
                                    _cache[67] || (_cache[67] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, " Taxe S. ", -1)),
                                    _withDirectives(_createElementVNode("input", {
                                      type: "number",
                                      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.produit.taxeSpecifique) = $event)),
                                      class: "form-control",
                                      placeholder: "",
                                      onKeyup: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.eventProduit && _ctx.eventProduit(...args)))
                                    }, null, 544), [
                                      [
                                        _vModelText,
                                        _ctx.produit.taxeSpecifique,
                                        void 0,
                                        { number: true }
                                      ]
                                    ]),
                                    _cache[68] || (_cache[68] = _createElementVNode("span", { class: "invalid-feedback" }, null, -1))
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_55, [
                                  _createElementVNode("div", _hoisted_56, [
                                    _cache[69] || (_cache[69] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, " Type RSE ", -1)),
                                    _createVNode(_component_Multiselect, {
                                      options: ['%', 'MT'],
                                      searchable: true,
                                      "track-by": "label",
                                      label: "label",
                                      modelValue: _ctx.produit.typeRemise,
                                      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.produit.typeRemise) = $event)),
                                      placeholder: "...",
                                      onSelect: _ctx.eventProduit
                                    }, null, 8, ["modelValue", "onSelect"])
                                  ]),
                                  _createElementVNode("div", _hoisted_57, [
                                    _cache[70] || (_cache[70] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, " Valeur remise ", -1)),
                                    _withDirectives(_createElementVNode("input", {
                                      type: "text",
                                      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.produit.valeurRemise) = $event)),
                                      class: "form-control",
                                      placeholder: "",
                                      onKeyup: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.eventProduit && _ctx.eventProduit(...args)))
                                    }, null, 544), [
                                      [
                                        _vModelText,
                                        _ctx.produit.valeurRemise,
                                        void 0,
                                        { number: true }
                                      ]
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_58, [
                                    _cache[71] || (_cache[71] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, " MT Remise ", -1)),
                                    _withDirectives(_createElementVNode("input", {
                                      type: "text",
                                      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.produit.remise) = $event)),
                                      readonly: true,
                                      class: "form-control",
                                      placeholder: ""
                                    }, null, 512), [
                                      [_vModelText, _ctx.produit.remise]
                                    ]),
                                    _cache[72] || (_cache[72] = _createElementVNode("span", { class: "invalid-feedback" }, null, -1))
                                  ]),
                                  _createElementVNode("div", _hoisted_59, [
                                    _cache[73] || (_cache[73] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, " MT. HT Ap Rse ", -1)),
                                    _withDirectives(_createElementVNode("input", {
                                      type: "text",
                                      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.produit.montantHtApresRemise) = $event)),
                                      readonly: true,
                                      class: "form-control",
                                      placeholder: ""
                                    }, null, 512), [
                                      [_vModelText, _ctx.produit.montantHtApresRemise]
                                    ]),
                                    _cache[74] || (_cache[74] = _createElementVNode("span", { class: "invalid-feedback" }, null, -1))
                                  ]),
                                  _createElementVNode("div", _hoisted_60, [
                                    _cache[75] || (_cache[75] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, " MT. TVA ", -1)),
                                    _withDirectives(_createElementVNode("input", {
                                      type: "text",
                                      "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.produit.montantTva) = $event)),
                                      readonly: true,
                                      class: "form-control",
                                      placeholder: ""
                                    }, null, 512), [
                                      [_vModelText, _ctx.produit.montantTva]
                                    ]),
                                    _cache[76] || (_cache[76] = _createElementVNode("span", { class: "invalid-feedback" }, null, -1))
                                  ]),
                                  _createElementVNode("div", _hoisted_61, [
                                    _cache[77] || (_cache[77] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, " MT. TTC ", -1)),
                                    _withDirectives(_createElementVNode("input", {
                                      type: "text",
                                      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.produit.montantTtc) = $event)),
                                      readonly: true,
                                      class: "form-control",
                                      placeholder: ""
                                    }, null, 512), [
                                      [_vModelText, _ctx.produit.montantTtc]
                                    ]),
                                    _cache[78] || (_cache[78] = _createElementVNode("span", { class: "invalid-feedback" }, null, -1))
                                  ]),
                                  _createElementVNode("div", _hoisted_62, [
                                    _cache[79] || (_cache[79] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, " Magasin ", -1)),
                                    _createVNode(_component_Multiselect, {
                                      options: _ctx.magasin1Options,
                                      searchable: true,
                                      "track-by": "label",
                                      label: "label",
                                      modelValue: _ctx.produit.magasin,
                                      "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.produit.magasin) = $event)),
                                      placeholder: "",
                                      onSelect: _cache[33] || (_cache[33] = ($event: any) => (_ctx.updateStockByMagasin(_ctx.produit)))
                                    }, null, 8, ["options", "modelValue"]),
                                    (_ctx.validateRowProduit(_ctx.produit.magasin))
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_63, " Champ obligatoire "))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("div", _hoisted_64, [
                                    _cache[80] || (_cache[80] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, " Stock ", -1)),
                                    _createElementVNode("p", _hoisted_65, "Logigique: " + _toDisplayString(_ctx.produit.stockLogique || 0), 1),
                                    _createElementVNode("p", _hoisted_66, "Physique: " + _toDisplayString(_ctx.produit.stockPhysique || 0), 1)
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_67, [
                      _createElementVNode("div", _hoisted_68, [
                        _createElementVNode("div", _hoisted_69, [
                          _createElementVNode("div", _hoisted_70, [
                            _cache[82] || (_cache[82] = _createElementVNode("div", { class: "col-md-7" }, [
                              _createElementVNode("h3", { class: "fs-4 text-white" }, " Entête de la facture ")
                            ], -1)),
                            _createElementVNode("div", _hoisted_71, [
                              _createElementVNode("div", _hoisted_72, [
                                _createElementVNode("button", {
                                  class: _normalizeClass(["default-btn me-20 transition border-0 fw-medium text-white pt-2 pb-2 ps-8 pe-8 rounded-1 fs-md-13 fs-lg-14 bg-success", {
                                'cursor-not-allowed': _ctx.isDisableElement,
                              }]),
                                  type: "button",
                                  disabled: _ctx.isDisableElement,
                                  onClick: _cache[34] || (_cache[34] = 
//@ts-ignore
(...args) => (_ctx.addRowElement && _ctx.addRowElement(...args)))
                                }, _cache[81] || (_cache[81] = [
                                  _createElementVNode("i", { class: "fa fa-plus-circle position-relative ms-5 fs-12" }, null, -1),
                                  _createTextVNode(" Ajouter une entête ")
                                ]), 10, _hoisted_73)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _cache[84] || (_cache[84] = _createElementVNode("div", { class: "row d-flex align-items-center justify-content-between mt-10" }, [
                              _createElementVNode("div", { class: "col-md-3" }, [
                                _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                                  _createTextVNode(" Titre "),
                                  _createElementVNode("span", { class: "text-danger" }, "*")
                                ])
                              ]),
                              _createElementVNode("div", { class: "col-md-3" }, [
                                _createElementVNode("label", { class: "d-block text-black fw-semibold" }, "Description")
                              ]),
                              _createElementVNode("div", { class: "col-md-2" }, [
                                _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                                  _createTextVNode(" Taille police "),
                                  _createElementVNode("span", { class: "text-danger" }, "*")
                                ])
                              ]),
                              _createElementVNode("div", { class: "col-md-3" }, [
                                _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                                  _createTextVNode(" Alignement "),
                                  _createElementVNode("span", { class: "text-danger" }, "*")
                                ])
                              ]),
                              _createElementVNode("div", { class: "col-md-1" }, [
                                _createElementVNode("label", { class: "d-block text-black fw-semibold" }, " Action ")
                              ])
                            ], -1)),
                            _cache[85] || (_cache[85] = _createElementVNode("hr", { class: "mt-0" }, null, -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.elements, (element, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "row mb-5",
                                key: index
                              }, [
                                _createElementVNode("div", _hoisted_74, [
                                  _createVNode(_component_Field, {
                                    name: "titre",
                                    type: "text",
                                    modelValue: element.titre,
                                    "onUpdate:modelValue": ($event: any) => ((element.titre) = $event),
                                    class: "form-control shadow-none fs-md-15 text-black",
                                    placeholder: "Entrer le titre"
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                  (_ctx.validateRowElement(element.titre))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_75, " Le titre est obligatoire. "))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_76, [
                                  _createVNode(_component_Field, {
                                    name: "description",
                                    type: "text",
                                    modelValue: element.description,
                                    "onUpdate:modelValue": ($event: any) => ((element.description) = $event),
                                    class: "form-control shadow-none fs-md-15 text-black",
                                    placeholder: ""
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _createElementVNode("div", _hoisted_77, [
                                  _createVNode(_component_Field, {
                                    name: "taillePolice",
                                    type: "number",
                                    modelValue: element.taillePolice,
                                    "onUpdate:modelValue": ($event: any) => ((element.taillePolice) = $event),
                                    class: "form-control shadow-none fs-md-15 text-black",
                                    placeholder: ""
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _createElementVNode("div", _hoisted_78, [
                                  _createVNode(_component_Multiselect, {
                                    options: ['Centre', 'Gauche', 'Droite'],
                                    searchable: true,
                                    "track-by": "label",
                                    label: "label",
                                    modelValue: element.alignement,
                                    "onUpdate:modelValue": ($event: any) => ((element.alignement) = $event),
                                    placeholder: ""
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _createElementVNode("div", _hoisted_79, [
                                  _createElementVNode("button", {
                                    class: "btn btn-danger transition border-0 pb-2 ps-8 pe-8",
                                    type: "button",
                                    onClick: ($event: any) => (_ctx.removeRowElement(index))
                                  }, _cache[83] || (_cache[83] = [
                                    _createElementVNode("i", { class: "icofont icofont-ui-delete" }, null, -1)
                                  ]), 8, _hoisted_80)
                                ])
                              ]))
                            }), 128))
                          ])
                        ])
                      ])
                    ]),
                    (_ctx.prixErrorMessage)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                          _cache[86] || (_cache[86] = _createElementVNode("i", { class: "fa fa-exclamation-triangle me-2" }, null, -1)),
                          _createTextVNode(_toDisplayString(_ctx.prixErrorMessage), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_82, [
                _createElementVNode("table", _hoisted_83, [
                  _cache[91] || (_cache[91] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", {
                        scope: "col",
                        class: "produit info"
                      }, " Produit "),
                      _createElementVNode("th", {
                        scope: "col",
                        class: "quantite"
                      }, " Quantité "),
                      _createElementVNode("th", {
                        scope: "col",
                        class: "prix-unitaire"
                      }, " Prix unitaire "),
                      _createElementVNode("th", {
                        scope: "col",
                        class: ""
                      }, " Prix HT "),
                      _createElementVNode("th", {
                        scope: "col",
                        class: ""
                      }, " Montant HT "),
                      _createElementVNode("th", {
                        scope: "col",
                        class: "taxe"
                      }, " Taxe S. "),
                      _createElementVNode("th", {
                        scope: "col",
                        class: "type-rse"
                      }, " Type RSE "),
                      _createElementVNode("th", {
                        scope: "col",
                        class: "vente-rse"
                      }, " Vente / RSE "),
                      _createElementVNode("th", {
                        scope: "col",
                        class: ""
                      }, " MT Remise "),
                      _createElementVNode("th", { scope: "col" }, " MT. HT Ap Rse "),
                      _createElementVNode("th", {
                        scope: "col",
                        class: ""
                      }, " MT. TVA "),
                      _createElementVNode("th", {
                        scope: "col",
                        class: "text pe-0"
                      }, " MT. TTC "),
                      _createElementVNode("th", {
                        scope: "col",
                        class: "magasin"
                      }, " Magasin "),
                      _createElementVNode("th", {
                        scope: "col",
                        class: "actions pe-0"
                      }, " ACTIONS ")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.produits, (produit, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", _hoisted_84, [
                          _createElementVNode("span", _hoisted_85, _toDisplayString(produit.libelleProduit), 1)
                        ]),
                        _createElementVNode("td", _hoisted_86, _toDisplayString(produit.qtite), 1),
                        _createElementVNode("td", _hoisted_87, _toDisplayString(produit.prixTtc), 1),
                        _createElementVNode("td", _hoisted_88, _toDisplayString(produit.prixHt), 1),
                        _createElementVNode("td", _hoisted_89, _toDisplayString(produit.montantHt), 1),
                        _createElementVNode("td", _hoisted_90, _toDisplayString(produit.taxeSpecifique), 1),
                        _createElementVNode("td", _hoisted_91, _toDisplayString(produit.typeRemise), 1),
                        _createElementVNode("td", _hoisted_92, _toDisplayString(produit.valeurRemise), 1),
                        _createElementVNode("td", _hoisted_93, _toDisplayString(produit.remise), 1),
                        _createElementVNode("td", _hoisted_94, _toDisplayString(produit.montantHtApresRemise), 1),
                        _createElementVNode("td", _hoisted_95, _toDisplayString(produit.montantTva), 1),
                        _createElementVNode("td", _hoisted_96, _toDisplayString(produit.montantTtc), 1),
                        _createElementVNode("td", _hoisted_97, _toDisplayString(_ctx.getMagasinLabel(produit.magasin)), 1),
                        _createElementVNode("td", _hoisted_98, [
                          _createElementVNode("div", _hoisted_99, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-info transition border-0 pb-2 ps-8 pe-8",
                              onClick: ($event: any) => (_ctx.showDetails(produit)),
                              "data-bs-toggle": "modal",
                              "data-bs-target": "#stockDetailsModal"
                            }, _cache[88] || (_cache[88] = [
                              _createElementVNode("i", { class: "fa fa-eye" }, null, -1)
                            ]), 8, _hoisted_100),
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-warnign transition border-0 pb-2 ps-8 pe-8",
                              onClick: ($event: any) => (_ctx.editProduit(index))
                            }, _cache[89] || (_cache[89] = [
                              _createElementVNode("i", { class: "icofont icofont-ui-edit" }, null, -1)
                            ]), 8, _hoisted_101),
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-danger transition border-0 pb-2 ps-8 pe-8",
                              onClick: ($event: any) => (_ctx.removeRowProduit(index))
                            }, _cache[90] || (_cache[90] = [
                              _createElementVNode("i", { class: "icofont icofont-ui-delete" }, null, -1)
                            ]), 8, _hoisted_102)
                          ])
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_103, [
                _createElementVNode("div", _hoisted_104, [
                  _createElementVNode("div", _hoisted_105, [
                    _cache[105] || (_cache[105] = _createElementVNode("div", { class: "modal-header" }, [
                      _createElementVNode("h5", null, "Détails du produit"),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn-close",
                        "data-bs-dismiss": "modal",
                        "aria-label": "Close"
                      })
                    ], -1)),
                    _createElementVNode("div", _hoisted_106, [
                      _createElementVNode("div", _hoisted_107, [
                        _createElementVNode("div", _hoisted_108, [
                          _cache[92] || (_cache[92] = _createElementVNode("p", { class: "fw-bold mb-1" }, "Produit :", -1)),
                          _createElementVNode("p", null, _toDisplayString(_ctx.selectedProduit?.libelleProduit || 'Non défini'), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_109, [
                        _createElementVNode("div", _hoisted_110, [
                          _cache[93] || (_cache[93] = _createElementVNode("p", { class: "fw-bold mb-1" }, "Quantité :", -1)),
                          _createElementVNode("p", null, _toDisplayString(_ctx.selectedProduit?.qtite || 'Non défini'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_111, [
                          _cache[94] || (_cache[94] = _createElementVNode("p", { class: "fw-bold mb-1" }, "Prix unitaire :", -1)),
                          _createElementVNode("p", null, _toDisplayString(_ctx.selectedProduit?.prixTtc || 'Non défini'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_112, [
                          _cache[95] || (_cache[95] = _createElementVNode("p", { class: "fw-bold mb-1" }, "Prix HT :", -1)),
                          _createElementVNode("p", null, _toDisplayString(_ctx.selectedProduit?.prixHt || 'Non défini'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_113, [
                          _cache[96] || (_cache[96] = _createElementVNode("p", { class: "fw-bold mb-1" }, "Montant HT :", -1)),
                          _createElementVNode("p", null, _toDisplayString(_ctx.selectedProduit?.montantHt || 'Non défini'), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_114, [
                        _createElementVNode("div", _hoisted_115, [
                          _cache[97] || (_cache[97] = _createElementVNode("p", { class: "fw-bold mb-1" }, "Taxe S. :", -1)),
                          _createElementVNode("p", null, _toDisplayString(_ctx.selectedProduit?.taxeSpecifique || 'Non défini'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_116, [
                          _cache[98] || (_cache[98] = _createElementVNode("p", { class: "fw-bold mb-1" }, "Type RSE :", -1)),
                          _createElementVNode("p", null, _toDisplayString(_ctx.selectedProduit?.typeRemise || 'Non défini'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_117, [
                          _cache[99] || (_cache[99] = _createElementVNode("p", { class: "fw-bold mb-1" }, "Valeur RSE :", -1)),
                          _createElementVNode("p", null, _toDisplayString(_ctx.selectedProduit?.valeurRemise || 'Non défini'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_118, [
                          _cache[100] || (_cache[100] = _createElementVNode("p", { class: "fw-bold mb-1" }, "MT Remise :", -1)),
                          _createElementVNode("p", null, _toDisplayString(_ctx.selectedProduit?.remise || 'Non défini'), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_119, [
                        _createElementVNode("div", _hoisted_120, [
                          _cache[101] || (_cache[101] = _createElementVNode("p", { class: "fw-bold mb-1" }, "MT. HT Ap Rse :", -1)),
                          _createElementVNode("p", null, _toDisplayString(_ctx.selectedProduit?.montantHtApresRemise || 'Non défini'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_121, [
                          _cache[102] || (_cache[102] = _createElementVNode("p", { class: "fw-bold mb-1" }, "MT. TVA :", -1)),
                          _createElementVNode("p", null, _toDisplayString(_ctx.selectedProduit?.montantTva || 'Non défini'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_122, [
                          _cache[103] || (_cache[103] = _createElementVNode("p", { class: "fw-bold mb-1" }, "MT. TTC :", -1)),
                          _createElementVNode("p", null, _toDisplayString(_ctx.selectedProduit?.montantTtc || 'Non défini'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_123, [
                          _cache[104] || (_cache[104] = _createElementVNode("p", { class: "fw-bold mb-1" }, "Magasin :", -1)),
                          _createElementVNode("p", null, _toDisplayString(_ctx.getMagasinLabel(_ctx.selectedProduit?.magasin)), 1)
                        ])
                      ])
                    ]),
                    _cache[106] || (_cache[106] = _createElementVNode("div", { class: "modal-footer" }, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-secondary",
                        "data-bs-dismiss": "modal"
                      }, " Fermer ")
                    ], -1))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_124, [
                _createElementVNode("div", _hoisted_125, [
                  _createElementVNode("div", _hoisted_126, [
                    _cache[117] || (_cache[117] = _createElementVNode("div", { class: "modal-header text-white" }, [
                      _createElementVNode("h5", { class: "modal-title" }, "Billetage de Vente"),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn-close btn-close-white",
                        "data-bs-dismiss": "modal",
                        "aria-label": "Close"
                      })
                    ], -1)),
                    _createElementVNode("div", _hoisted_127, [
                      _createElementVNode("div", _hoisted_128, [
                        _createElementVNode("div", _hoisted_129, [
                          _createElementVNode("div", _hoisted_130, [
                            _createElementVNode("div", _hoisted_131, [
                              _cache[107] || (_cache[107] = _createElementVNode("div", { class: "col-md-7" }, [
                                _createElementVNode("h3", { class: "h3 fs-5 text-white mb-0" }, "Billetage Encaissement")
                              ], -1)),
                              _createElementVNode("div", _hoisted_132, [
                                _createElementVNode("h3", _hoisted_133, _toDisplayString(_ctx.montantTotalEncaissement || 0) + " Fcfa ", 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_134, [
                              _cache[108] || (_cache[108] = _createElementVNode("div", { class: "row mt-2 fw-semibold" }, [
                                _createElementVNode("div", { class: "col-md-4" }, [
                                  _createElementVNode("label", null, "Monnaie")
                                ]),
                                _createElementVNode("div", { class: "col-md-4" }, [
                                  _createElementVNode("label", null, "Quantité")
                                ]),
                                _createElementVNode("div", { class: "col-md-4" }, [
                                  _createElementVNode("label", null, "Montant")
                                ])
                              ], -1)),
                              _cache[109] || (_cache[109] = _createElementVNode("hr", { class: "mt-1 mb-2" }, null, -1)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.billetageList, (billetage, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: 'enc-' + index,
                                  class: "row align-items-center mb-2"
                                }, [
                                  _createElementVNode("div", _hoisted_135, [
                                    _withDirectives(_createElementVNode("input", {
                                      "onUpdate:modelValue": ($event: any) => ((billetage.libelle) = $event),
                                      readonly: "",
                                      class: "form-control form-control-sm"
                                    }, null, 8, _hoisted_136), [
                                      [_vModelText, billetage.libelle]
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_137, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "number",
                                      min: "0",
                                      "onUpdate:modelValue": ($event: any) => ((billetage.qteBillet) = $event),
                                      onInput: ($event: any) => (_ctx.handleBilletageInput($event, billetage, 'encaissement')),
                                      onKeypress: _cache[35] || (_cache[35] = ($event: any) => (_ctx.restrictInput($event))),
                                      class: "form-control form-control-sm",
                                      placeholder: "0"
                                    }, null, 40, _hoisted_138), [
                                      [
                                        _vModelText,
                                        billetage.qteBillet,
                                        void 0,
                                        { number: true }
                                      ]
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_139, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "text",
                                      "onUpdate:modelValue": ($event: any) => ((billetage.montant) = $event),
                                      readonly: "",
                                      class: "form-control form-control-sm"
                                    }, null, 8, _hoisted_140), [
                                      [_vModelText, billetage.montant]
                                    ])
                                  ])
                                ]))
                              }), 128))
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_141, [
                          _createElementVNode("div", _hoisted_142, [
                            _createElementVNode("div", _hoisted_143, [
                              _cache[110] || (_cache[110] = _createElementVNode("div", { class: "col-md-7" }, [
                                _createElementVNode("h3", { class: "h3 fs-5 text-white mb-0" }, "Reliquat à Rendre")
                              ], -1)),
                              _createElementVNode("div", _hoisted_144, [
                                _createElementVNode("h3", _hoisted_145, _toDisplayString(_ctx.reliquatCalcule || 0) + " Fcfa ", 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_146, [
                              _cache[111] || (_cache[111] = _createElementVNode("div", { class: "row mt-2 fw-semibold" }, [
                                _createElementVNode("div", { class: "col-md-4" }, [
                                  _createElementVNode("label", null, "Monnaie")
                                ]),
                                _createElementVNode("div", { class: "col-md-4" }, [
                                  _createElementVNode("label", null, "Quantité")
                                ]),
                                _createElementVNode("div", { class: "col-md-4" }, [
                                  _createElementVNode("label", null, "Montant")
                                ])
                              ], -1)),
                              _cache[112] || (_cache[112] = _createElementVNode("hr", { class: "mt-1 mb-2" }, null, -1)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.billetageSortieList, (billetage, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: 'sort-' + index,
                                  class: "row align-items-center mb-2"
                                }, [
                                  _createElementVNode("div", _hoisted_147, [
                                    _withDirectives(_createElementVNode("input", {
                                      "onUpdate:modelValue": ($event: any) => ((billetage.libelle) = $event),
                                      readonly: "",
                                      class: "form-control form-control-sm"
                                    }, null, 8, _hoisted_148), [
                                      [_vModelText, billetage.libelle]
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_149, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "number",
                                      min: "0",
                                      "onUpdate:modelValue": ($event: any) => ((billetage.qteBillet) = $event),
                                      onInput: ($event: any) => (_ctx.handleBilletageInput($event, billetage, 'sortie')),
                                      onKeypress: _cache[36] || (_cache[36] = ($event: any) => (_ctx.restrictInput($event))),
                                      class: "form-control form-control-sm",
                                      placeholder: "0"
                                    }, null, 40, _hoisted_150), [
                                      [
                                        _vModelText,
                                        billetage.qteBillet,
                                        void 0,
                                        { number: true }
                                      ]
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_151, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "text",
                                      "onUpdate:modelValue": ($event: any) => ((billetage.montant) = $event),
                                      readonly: "",
                                      class: "form-control form-control-sm"
                                    }, null, 8, _hoisted_152), [
                                      [_vModelText, billetage.montant]
                                    ])
                                  ])
                                ]))
                              }), 128)),
                              (_ctx.montantTotalSortie > _ctx.reliquatCalcule)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_153, [
                                    _createElementVNode("small", null, "Le billetage de sortie (" + _toDisplayString(_ctx.montantTotalSortie) + " Fcfa) dépasse le reliquat (" + _toDisplayString(_ctx.reliquatCalcule) + " Fcfa).", 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ]),
                      (_ctx.billetageError)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_154, [
                            _cache[113] || (_cache[113] = _createElementVNode("i", { class: "fa fa-exclamation-triangle me-2" }, null, -1)),
                            _createTextVNode(_toDisplayString(_ctx.billetageError), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.reliquatNonRendu > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_155, [
                            _cache[114] || (_cache[114] = _createElementVNode("i", { class: "fa fa-exclamation-triangle me-2" }, null, -1)),
                            _createTextVNode("Reliquat non rendu au client: " + _toDisplayString(_ctx.reliquatNonRendu) + " Fcfa ", 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_156, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-primary",
                        onClick: _cache[37] || (_cache[37] = 
//@ts-ignore
(...args) => (_ctx.validerBilletage && _ctx.validerBilletage(...args))),
                        "data-bs-dismiss": "modal",
                        disabled: _ctx.montantTotalEncaissement < _ctx.totalttc || _ctx.montantTotalSortie > _ctx.reliquatCalcule
                      }, _cache[115] || (_cache[115] = [
                        _createElementVNode("i", { class: "fa fa-check me-1" }, null, -1),
                        _createTextVNode(" Valider ")
                      ]), 8, _hoisted_157),
                      _cache[116] || (_cache[116] = _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-secondary",
                        "data-bs-dismiss": "modal"
                      }, [
                        _createElementVNode("i", { class: "fa fa-times me-1" }),
                        _createTextVNode(" Annuler ")
                      ], -1))
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_158, [
                _createElementVNode("div", _hoisted_159, [
                  _createElementVNode("div", _hoisted_160, [
                    _createElementVNode("div", _hoisted_161, [
                      _createElementVNode("button", {
                        type: "submit",
                        class: _normalizeClass(["btn btn-primary px-4", { 'cursor-not-allowed': _ctx.isDisable || (_ctx.showC && (!_ctx.montantTotalEncaissement || _ctx.montantTotalEncaissement < _ctx.totalttc)) }]),
                        disabled: _ctx.isDisable || (_ctx.showC && (!_ctx.montantTotalEncaissement || _ctx.montantTotalEncaissement < _ctx.totalttc))
                      }, _cache[118] || (_cache[118] = [
                        _createElementVNode("i", { class: "fa fa-exchange me-2" }, null, -1),
                        _createTextVNode(" Transformer en vente ")
                      ]), 10, _hoisted_162),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-primary dropdown-toggle dropdown-toggle-split",
                        "data-bs-toggle": "dropdown",
                        "aria-expanded": "false",
                        disabled: _ctx.isDisable
                      }, _cache[119] || (_cache[119] = [
                        _createElementVNode("span", { class: "visually-hidden" }, "Toggle Dropdown", -1)
                      ]), 8, _hoisted_163),
                      _createElementVNode("ul", _hoisted_164, [
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            class: _normalizeClass(["dropdown-item", { 'disabled': _ctx.showC && (!_ctx.montantTotalEncaissement || _ctx.montantTotalEncaissement < _ctx.totalttc) }]),
                            href: "#",
                            onClick: _cache[38] || (_cache[38] = _withModifiers($event => _ctx.$parent.$emit('submit'), ["prevent"]))
                          }, _cache[120] || (_cache[120] = [
                            _createElementVNode("i", { class: "fa fa-exchange" }, null, -1),
                            _createTextVNode(" Transformer en vente ")
                          ]), 2)
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            class: _normalizeClass(["dropdown-item", { 'disabled': _ctx.isGeneratingPdf || (_ctx.showC && (!_ctx.montantTotalEncaissement || _ctx.montantTotalEncaissement < _ctx.totalttc)) }]),
                            href: "#",
                            onClick: _cache[39] || (_cache[39] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSaveAndPrint && _ctx.handleSaveAndPrint(...args)), ["prevent"]))
                          }, [
                            (!_ctx.isGeneratingPdf)
                              ? (_openBlock(), _createElementBlock("i", _hoisted_165))
                              : (_openBlock(), _createElementBlock("i", _hoisted_166)),
                            _createTextVNode(" " + _toDisplayString(_ctx.isGeneratingPdf ? 'Génération...' : 'Transformer et imprimer'), 1)
                          ], 2)
                        ]),
                        _cache[121] || (_cache[121] = _createElementVNode("li", null, [
                          _createElementVNode("hr", { class: "dropdown-divider" })
                        ], -1))
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_167, [
                    _createVNode(_component_router_link, {
                      to: "/ventes/liste-ventes",
                      class: "btn btn-danger"
                    }, {
                      default: _withCtx(() => _cache[122] || (_cache[122] = [
                        _createElementVNode("i", { class: "fa fa-times me-1" }, null, -1),
                        _createTextVNode(" Annuler ")
                      ])),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_168, [
                    _createElementVNode("div", _hoisted_169, [
                      _cache[123] || (_cache[123] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, [
                        _createTextVNode(" Format impression "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createVNode(_component_Field, {
                        name: "formatImpression",
                        modelValue: _ctx.formatImpression,
                        "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.formatImpression) = $event))
                      }, {
                        default: _withCtx(({ field }) => [
                          _createVNode(_component_Multiselect, _mergeProps({
                            options: ['A4', 'A5', 'A6', 'T1', 'T2'],
                            searchable: true,
                            modelValue: field.value,
                            "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                          }, field, { placeholder: "Sélectionner" }), null, 16, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "formatImpression",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _cache[124] || (_cache[124] = _createElementVNode("div", { class: "col-md-2" }, [
                    _createElementVNode("div", { class: "btn-group" }, [
                      _createElementVNode("button", {
                        class: "btn btn-primary dropdown-toggle",
                        type: "button",
                        "data-bs-toggle": "dropdown"
                      }, " Modèle "),
                      _createElementVNode("ul", { class: "dropdown-menu" }, [
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            href: "#"
                          }, "Modèle 2")
                        ])
                      ])
                    ])
                  ], -1))
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema", "keep-values"])
      ])
    ]),
    _createVNode(_component_AddClientModal, { onGetclient: _ctx.getClient }, null, 8, ["onGetclient"])
  ], 64))
}